"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyType = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NotifyType = ({
  currentType,
  onChange
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    config
  } = (0, _contexts.useAppContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const [isSelected, setIsSelected] = (0, _react.useState)(currentType !== _models.BackInStockNotificationChannel.Email);
  const handleChange = (0, _react.useCallback)(({
    currentTarget: {
      checked
    }
  }) => {
    setIsSelected(checked);
    onChange(checked ? _models.BackInStockNotificationChannel.Sms : _models.BackInStockNotificationChannel.Email);
  }, [onChange]);
  if (!config?.smsSubscriptionEnabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    fullWidth: true,
    "data-testid": getTestId(_constants.NOTIFY_TYPE),
    checked: isSelected,
    firstText: translations.email,
    secondText: translations.sms,
    role: "radiogroup",
    onChange: handleChange
  });
};
exports.NotifyType = NotifyType;
